<template>
  <main class="main">
      <organization_header :dropshipping="true" v-if="$store.getters.getCompany.dropshipping"/>
      <div  v-if="$store.getters.getCompany.dropshipping">
          <app-button @click="fileInput" outlined class="ml-2">Загрузка xml</app-button>
          <app-button @click="refreshFile()" outlined class="ml-2">Обновить xml</app-button>
          <input type="file" ref="file" v-validate="'required'" data-vv-validate-on="blur" data-vv-as="xml" hidden name="file" accept=".xml"  @change="onFileChange">
          <span class="text-danger text-sm">{{ errors.first('file') }}</span>
      </div>
      <div class="table">
        <loading-container :loading="loading" >
            <div class="bordered-card" v-if="categories.length > 0">
                <div class="bordered-card__head">Мои товарные категории</div>
                <div class="bordered-card__items">
                    <div class="tree-container">
                        <tree :data="categories" :options="{checkbox: false, deletion: false}"/>
                    </div>
                </div>
            </div>
      </loading-container>
      </div>
  </main>
</template>

<script>

import LoadingContainer from "@/components/loading-container";
import AppButton from "@/components/app-button";
import organization_header from "@/components/OrganizationHeader.vue"

export default {
  name: "dropshipping-categories",
  components: {
    LoadingContainer,
    AppButton,
    organization_header
  },
  data: ()=>({
    file: '',
    categories: [],
    loading: true,
  }),
  mounted() {
    this.getCategories();
  },
  methods: {
    getCategories(){
      this.$http.post('/get-purchaser-categories', {
        token: localStorage.getItem('token'),
        page: this.page
      }).then(({data}) => {
        if (data.categories){
          this.categories = data.categories;
          this.loading = false;
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    onFileChange(e) {
      let t = e.target.files[0].type.split('/').pop().toLowerCase();
        if (t != "xml") {
          this.$refs.file.value = ''
          return this.$toast.error('Загружаемый файл должен быть xml!')
        }
        if (e.target.files[0].size > 5000000) {
          this.$refs.file.value = ''
          return this.$toast.error('Загружаемый файл должен иметь размер не более 5 мб.!')
        }
        this.file = e.target.files[0];
        this.send();
      },
    fileInput() {
      this.$refs.file.click();
    },
    send() {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.loading = true;
          let formData = new FormData();
          formData.append('file', this.file);
          formData.append('token', localStorage.getItem('token'));
          this.$http.post( '/parse-purchaser-categories',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then((response) => {
            if (response.data.success) {
              this.getCategories();
              this.$toast.success('Категории успешно загружены!');
            }
          }).catch(function(){
            this.$toast.error('Ошибка!');
          })
        }
      })
    },
    refreshFile() {
      this.$http.post('/refresh-dropshipping-products-xml',{
        token: localStorage.getItem('token'),
      }).then(({data}) => {
          if (data.success) {
            this.$toast.success('Xml успешно обновлен!');
          }
      }).catch(function(){
      })
    }
  }
}
</script>

<style lang="scss">
    .outlined {
        width: 200px !important;
    }
    .bordered-card{
        background: #FFFFFF;
        box-shadow: 0px 0px 3px #E5E5EA;
        border-radius: 4px;
        border: 1px solid #EEF0F3;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #2D3137;
        width: 50%;

    &__head{
         padding: 15px;
         border-bottom: 1px solid #EEF0F3;
     }
    &__items{
         background: #FFFFFF;
     }
    }
</style>
<style scoped lang="scss">

.table{
  margin-top: 20px;
  table{
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    tr{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;

      th{
        color: #2D3137;
      }
      td{
        color: #636974;
        &.done{
          color: #2cb181;
        }
      }
    }
  }
}

.bordered-card{
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    border: 1px solid #EEF0F3;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #2D3137;
    width: 50%;

    &__head{
         padding: 15px;
         border-bottom: 1px solid #EEF0F3;
     }
    &__items{
         background: #FFFFFF;
     }
}


</style>
